import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Container,
  Row,
  Col,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Cookies from 'js-cookie'

import {
  FaUser,
  FaEye,
  FaEdit,
  FaTrash,
  FaChalkboardTeacher,
  FaSyncAlt,
} from 'react-icons/fa'
// import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'

import toast from 'react-hot-toast'
import EditTeacherModal from './EditTeacherModal'
import { Eye, PencilSquare } from 'react-bootstrap-icons'
import { FaEyeSlash } from 'react-icons/fa'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from './AuthContext'

const TeacherTable = () => {
  const { user } = useAuth()
  console.log('USER ', user)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedTeacher, setSelectedTeacher] = useState(null)
  const [institute, setInstitute] = useState('')
  const [teacherImage, setTeacherImage] = useState(null)

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    const instituteName = Cookies.get('institute_name')

    console.log('instituteId', instituteId)
    console.log('instituteName', instituteName)

    setInstitute({ instituteId, name: instituteName })
    setNewTeacher((prev) => ({
      ...prev,
      institute_id: instituteId,
    }))
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL + '/teacher/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        setData(response.data.data)
        // setFilteredData(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [loading])
  const [newTeacher, setNewTeacher] = useState({
    name: '',
    dob: '',
    qualification: '',
    phone: '',
    email: '',
    // status: '',
    age: '',
    gender: '',
    address: '',
    password: '',
    joining_date: '',
    institute_id: '',
    id_proof_type: '',
    id_proof_number: '',
  })
  // Function to calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    // Adjust age if the birthday hasn't occurred yet this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewTeacher((prev) => ({ ...prev, [name]: value }))

    if (name === 'dob') {
      const age = calculateAge(value)
      setNewTeacher((prev) => ({
        ...prev,
        dob: value,
        age: age.toString(),
      }))
    } else {
      setNewTeacher((prev) => ({ ...prev, [name]: value }))
    }
  }

  // Add New Teacher
  const handleSave = async (e) => {
    e.preventDefault()

    try {
      setLoading(true)
      let imageUrl = null
      if (teacherImage) {
        if (teacherImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }
        const formData = new FormData()
        formData.append('image', teacherImage)
        formData.append('folder', 'teacher')

        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value)
        }

        const imageResponse = await axios.post(
          BASE_URL + '/upload-image',
          formData,
        )
        if (imageResponse.data && imageResponse.data.path) {
          imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        } else {
          throw new Error('Image upload failed.')
        }
      }
      const headers = {
        Authorization: `Bearer ${user.token}`,
      }
      const payload = {
        ...newTeacher,
        teacher_image: imageUrl,
        headers,
      }

      console.log('Sending data: ', newTeacher)
      const response = await ApiEndpoints.addTeacher({
        ...payload,
        password: newTeacher.password,
      })
      toast.success(response.data.message)

      setNewTeacher({
        name: '',
        dob: '',
        age: '',
        qualification: '',
        phone: '',
        email: '',
        // status: '',
        gender: '',
        address: '',
        password: '',
        joining_date: '',
        id_proof_type: '',
        id_proof_number: '',
        institute_id: '',
      })
      setTeacherImage(null)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.message || 'Something wents wrong.')
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const navigate = useNavigate()
  const handleTeacherProfile = (teacher) => {
    navigate(`/TeacherProfile/${teacher.id}`, { state: { teacher } })
  }
  const handleRefresh = async () => {
    setSearch({})

    setData(data)
    setSearch('')
    setCurrentPage(1)
  }

  const highlightText = (text, search) => {
    if (!search) return text

    const lowerText = text.toString().toLowerCase()
    const lowerSearch = search.toLowerCase()

    // Check if all characters from search exist in the text
    const allCharsMatch = [...lowerSearch].every((char) =>
      lowerText.includes(char),
    )

    if (!allCharsMatch) {
      // Return plain text if any character is missing
      return text
    }

    // Highlight matching characters
    return text
      .toString()
      .split('')
      .map((char, i) => {
        return lowerSearch.includes(char.toLowerCase()) ? (
          <span key={i} style={{ backgroundColor: 'yellow', color: 'black' }}>
            {char}
          </span>
        ) : (
          <span key={i}>{char}</span>
        )
      })
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0 ">Teachers</h2>
          <Button
            variant="light"
            className="fw-bold px-4 py-2 rounded shadow-sm d-flex align-items-center"
            onClick={() => setShowModal(true)}
          >
            <FaChalkboardTeacher size={18} className="me-2" />
            Add New Teacher
          </Button>
        </div>
      </div>

      <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col xs={12} md={3}>
          <Form.Control
            type="text"
            placeholder="Search Teacher Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>
      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <p className="text-black m-0">Total Teachers: {filteredData.length}</p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="30">30 per page</option>
        </Form.Select>
      </div>
      {/* Teacher Table */}

      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr>
            <Th>Name</Th>
            <Th>Date of Birth</Th>
            <Th>Qualification</Th>
            <Th>Phone</Th>
            <Th>Email</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <Tr key={index} className="align-middle">
                <Td>{highlightText(item.name, search)}</Td>
                <Td>
                  {item?.dob
                    ? new Date(item.dob).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      })
                    : null}
                </Td>
                <Td>{item.qualification}</Td>
                <Td>{item.phone}</Td>
                <Td>{item.email}</Td>
                <Td className="text-center">
                  <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                    <Button
                      variant="info"
                      onClick={() => handleTeacherProfile(item)}
                    >
                      <Eye />
                    </Button>
                    <Button
                      variant="warning"
                      className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2"
                      onClick={() => {
                        setSelectedTeacher(item)
                        setShowEditModal(true)
                      }}
                    >
                      <PencilSquare />
                    </Button>
                  </div>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan="8" className="text-center text-muted fw-bold p-4">
                No records found
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      {/* Total Records */}
      <div className="d-flex justify-content-end align-items-center">
        <Pagination className="mt-2">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New Teacher Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Teacher</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newTeacher.name}
                onChange={handleInputChange}
                placeholder="Enter Teacher's Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            {/* Date of Birth Field */}
            <Form.Group className="mb-3">
              <Form.Label>Date of Birth *</Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={newTeacher.dob}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Age</Form.Label>
              <Form.Control
                type="text"
                name="age"
                value={newTeacher.age}
                disabled
                className="p-2 border rounded bg-light"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Gender *</Form.Label>
              <Form.Select
                name="gender"
                value={newTeacher.gender}
                onChange={handleInputChange}
                required
              >
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </Form.Select>
            </Form.Group>

            {/* Qualification Field */}
            <Form.Group className="mb-3">
              <Form.Label>Qualification *</Form.Label>
              <Form.Control
                type="text"
                name="qualification"
                value={newTeacher.qualification}
                onChange={handleInputChange}
                placeholder="Enter Qualification"
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>ID Type *</Form.Label>
              <Form.Select
                name="id_proof_type"
                value={newTeacher.id_proof_type}
                onChange={handleInputChange}
                required
              >
                <option value="">Select</option>
                <option value="aadhar card">Aadhaar</option>
                <option value="voter card">Voter ID</option>
                <option value="license">License</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>ID Proof Number</Form.Label>
              <Form.Control
                type="number"
                name="id_proof_number"
                value={newTeacher.id_proof_number}
                onChange={handleInputChange}
                placeholder="Enter Roll Number"
                required
              />
            </Form.Group>

            {/* Phone Number Field */}
            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={newTeacher.phone}
                onChange={handleInputChange}
                placeholder="Enter Phone Number"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Institute</Form.Label>
              <FormSelect
                name="institute_id"
                value={institute.instituteId}
                disabled
              >
                <option value={institute.instituteId}>{institute.name}</option>
              </FormSelect>
            </Form.Group>

            {/* Email ID Field */}
            <Form.Group className="mb-3">
              <Form.Label>Email ID *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newTeacher.email}
                onChange={handleInputChange}
                placeholder="Enter Email ID"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password *</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={newTeacher.password}
                  onChange={handleInputChange}
                  placeholder="Enter Password"
                  className="p-2 border rounded"
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={togglePasswordVisibility}
                  title={showPassword ? 'Hide Password' : 'Show Password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Date of Join</Form.Label>
              <Form.Control
                type="date"
                name="joining_date"
                value={newTeacher.joining_date}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            {/* Address Field */}
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="address"
                value={newTeacher.address}
                onChange={handleInputChange}
                placeholder="Enter Address"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Teacher Image (PNG/JPG/JPEG)</Form.Label>

              <div className="d-flex align-items-center gap-3 mt-2 mb-2">
                <Form.Control
                  type="file"
                  accept="teacher_image/png, teacher_image/jpeg, teacher_image/jpg"
                  onChange={(e) => setTeacherImage(e.target.files[0])}
                  style={{ maxWidth: '700px' }}
                />
                {teacherImage && (
                  <img
                    src={URL.createObjectURL(teacherImage)}
                    alt="Preview"
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: 'cover',
                      borderRadius: 8,
                      border: '1px solid #ccc',
                    }}
                  />
                )}
              </div>
            </Form.Group>
            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Save Teacher
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditTeacherModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        teacher={selectedTeacher}
      />
    </div>
  )
}

export default TeacherTable
